var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2817",
    "data-name": "Group 2817",
    transform: "translate(-1122 -264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 65,
    height: 55,
    rx: 5,
    transform: "translate(1122 264)",
    fill: "rgba(116,191,144,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M755.984,80.967A11.984,11.984,0,1,0,744,68.984,12.019,12.019,0,0,0,755.984,80.967Z",
    transform: "translate(398.811 222.538)",
    fill: "#0f8c5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M749.75,67.561l3.391,3.391,6.795-6.783",
    transform: "translate(399.951 223.96)",
    fill: "none",
    stroke: "#eef8f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTransaction);
export default __webpack_public_path__ + "static/media/successful-transaction.5ce7f294eaaade77bc86277b36301a98.svg";
export { ForwardRef as ReactComponent };